import { render, staticRenderFns } from "./VanTruckKH.vue?vue&type=template&id=48a66560"
import script from "./VanTruckKH.vue?vue&type=script&lang=js"
export * from "./VanTruckKH.vue?vue&type=script&lang=js"
import style0 from "./VanTruckKH.vue?vue&type=style&index=0&id=48a66560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports